import { render } from "./DocumentsGrid.vue?vue&type=template&id=52a16232&scoped=true"
import script from "./DocumentsGrid.vue?vue&type=script&lang=js"
export * from "./DocumentsGrid.vue?vue&type=script&lang=js"

import "./DocumentsGrid.vue?vue&type=style&index=0&id=52a16232&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a16232"]])

export default __exports__